<template>
    <div class="diagnosticResults-mobile">
        <div class="diagnosticResults-header">
            <h2 class="mt-2">Результаты диагностики</h2>
            <div class="badge" :class="getPassTypeBadgeClass(resultObject)">{{ resultObject.passTypeName }}</div>
            <div class="header-container">
                <div class="header-top">
                    <div class="header-info">
                        <div class="info-item">
                            <p>Дисциплина</p>
                            <p>{{ resultObject.studyDisciplineName }}</p>
                        </div>
                        <div class="info-item">
                            <p>Тема</p>
                            <p>{{ resultObject.description }}</p>
                        </div>
                    </div>
                    <div v-if="dialog" class="header-time">
                        <p>Дата прохождения</p>
                        <p style="color: black;">{{ resultObject.createdDate | filterBirthday }}</p>
                    </div>
                </div>
               <div class="header-bot">
                   <h3>{{ resultObject.title }}</h3>
                   <div class="header-patient">
                       <div class="patient-info">
                           <div class="item-name">
                               <img :src="getPhotoUrl(resultObject.patient)" class="name-icon" alt="icon">
                               <div class="name-txtContainer">
                                   <span>{{ resultObject.patient.fio }}</span>
                                   <div class="patient-itemInfo">
                                       <div class="gender-container">
                                           <span>Пол:</span>
                                           <div class="gender" :class="{'male': resultObject.patient.gender === 0,'female': resultObject.patient.gender === 1}">
                                                {{ resultObject.patient.gender === 0 ? 'М' : 'Ж' }}
                                            </div>
                                       </div>
                                       <div class="gender-container">
                                           <span>Возраст:</span>
                                           <div class="age-txt">{{ resultObject.patient.episodes[0].ageValue | calculateAgeByDays }}</div>
                                       </div>
                                   </div>
                               </div>
                           </div>
                           <div class="item-test">
                                <p>Описание теста</p>
                                <div class="test-name">
                                    <p>{{ resultObject.description  }}</p>
                                </div>
                            </div>
                       </div>
                       <div class="header-stats">
                           <div class="stats-item">
                               <p>Время прохождения</p>
                               <p>
                                   <timerComponent style="font-size:20px;" :time="prettyTime" />
                               </p>
                           </div>
                           <div class="stats-item">
                               <p>Общий балл</p>
                               <p>{{ resultObject.score }}</p>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
       </div>
       <div class="diagnosticResults-body">
           <h3>Таблица с критериями</h3>
           <div v-for="(item, key) in resultObject.criteries" :key="'e'+key" class="diagnosticResults-body-item">
            <div class="title-item">
               <p>{{ item.title }}</p>
               <v-btn @click="item.isOpen = !item.isOpen" small icon>
                    <v-icon>
                        {{ item.isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                    </v-icon>
                </v-btn>
            </div>
            <v-expand-transition>
                <div v-show="item.isOpen" class="table-cell">
                    <span>Количество набранных баллов</span>
                    <span style="font-weight: 500;">{{ item.score }}</span>
                    <span>Комментарий</span>
                    <span style="font-weight: 500;">{{ item.scoreText }}</span>
                    <a
                        @click.prevent="item.showAnswer = !item.showAnswer"
                        rel="noopener noreferrer"
                    >
                        {{item.showAnswer ? 'Скрыть правильный ответ'  : 'Посмотреть правильный ответ' }}
                    </a>
                    
                    <div v-if="item.showAnswer">
                        <v-divider class="mt-2 mb-2" />

                        <span v-if="item.title === 'Время диагностики'">
                            <th class="pb-2">Время прохождения:</th>
                            <br>
                            <timerComponent :time="etalonTime" />
                        </span>

                        <div v-for="(it, index) in item.correctAnswers" :key="'p'+index">
                            <th v-if="index === 0" class="pb-2">Правильный ответ:</th>
                            <span>{{ it.sectionName ? it.sectionName : ''}} </span>
                            <span v-if="item.title === 'Постановка синдромального диагноза'">{{ it.diagnoseName ? it.diagnoseName : ''}} </span>
                            <span v-if="item.title === 'Постановка предварительного диагноза'">{{ it.diagnoseName ? it.diagnoseName : ''}} </span>
                            <span v-if="item.title === 'Постановка окончательного диагноза'">{{ it.diagnoseName ? it.diagnoseName : ''}} </span>

                            <span v-if="item.title === 'Выбор лабораторных исследований' || item.title === 'Выбор инструментальных исследований'">
                                <span v-if="it.valueType === 1">
                                    {{ it.propertyName }}: {{ it.listValueName }}
                                </span>
                                <span v-if="it.valueType === 0">
                                    {{ it.propertyName }}: {{ it.avgValue }} {{ it.measurementName }}
                                </span>
                            </span>

                            <span v-if="item.title === 'Порядок лабораторных исследований' || item.title === 'Порядок инструментальных исследований'">
                                <span v-if="it.valueType === 1">
                                    {{it.groupName}}: {{ it.propertyName }}({{ it.listValueName }})
                                </span>
                                <span v-if="it.valueType === 0">
                                    {{it.groupName}}:{{ it.propertyName }}({{ it.avgValue }}) {{ it.measurementName }}
                                </span>
                            </span>

                            <span v-if="item.title === 'Определение патологии'">
                                <span v-if="it.valueType !== null && it.valueType === 1">
                                    {{ it.pathologyName }}: {{ it.listValueName }}
                                </span>
                                <span v-if="it.valueType !== null && it.valueType === 0">
                                    {{ it.pathologyName }}: {{ it.avgValue }} {{ it.measurementName }}
                                </span>
                                <span v-if="it.valueType === null">
                                    <p>{{ it.pathologyName }}</p>
                                </span>
                            </span>
                        </div>

                        <v-divider class="mt-2 mb-2" />

                        <span v-if="item.title === 'Время диагностики'">
                            <th class="pb-2">Время прохождения студентом:</th>
                            <br>
                            <timerComponent :time="prettyTime" />
                        </span>

                        <div v-for="(it, index) in item.studentAnswers" :key="'p2'+index">
                            <th v-if="index === 0" class="pb-2">Ответ студента:</th>

                            <span>{{ it.sectionName ? it.sectionName : ''}} </span>
                            <span v-if="item.title === 'Постановка синдромального диагноза'">{{ it.diagnoseName ? it.diagnoseName : ''}} </span>
                            <span v-if="item.title === 'Постановка предварительного диагноза'">{{ it.diagnoseName ? it.diagnoseName : ''}} </span>
                            <span v-if="item.title === 'Постановка окончательного диагноза'">{{ it.diagnoseName ? it.diagnoseName : ''}} </span>
                            
                            <span v-if="item.title === 'Выбор лабораторных исследований' || item.title === 'Выбор инструментальных исследований'">
                                <span v-if="it.answerValueType === 0">
                                    {{ it.answerGroupName }}: {{ it.answerPropertyName }} ({{ it.answerAvgValue ? it.answerAvgValue : '' }}) {{ it.answerMeasurementName }}
                                </span>
                                <span v-if="it.answerValueType === 1">
                                    {{ it.answerGroupName }}: {{ it.answerPropertyName }} ({{ it.answerListValueName}})
                                </span>
                            </span>

                            <span v-if="item.title === 'Порядок лабораторных исследований' || item.title === 'Порядок инструментальных исследований'">
                                <span v-if="it.answerValueType === 0">
                                    {{ it.answerGroupName }}: {{ it.answerPropertyName }} ({{ it.answerAvgValue ? it.answerAvgValue : '' }}) {{ it.answerMeasurementName }}
                                </span>
                                <span v-if="it.answerValueType === 1">
                                    {{ it.answerGroupName }}: {{ it.answerPropertyName }} ({{ it.answerListValueName}})
                                </span>
                            </span>

                            <span v-if="item.title === 'Определение патологии'">
                                    <span v-if="it.valueType !== null && it.valueType === 1">
                                    {{ it.pathologyName }}: {{ it.listValueName }}
                                </span>
                                <span v-if="it.valueType !== null && it.valueType === 0">
                                    {{ it.pathologyName }}: {{ it.avgValue }} {{ it.measurementName }}
                                </span>
                                <span v-if="it.valueType === null">
                                    <p>{{ it.pathologyName }}</p>
                                </span>
                            </span>
                        </div>
                        
                        <p v-if="item.link">Ссылка/ссылки на обучающий материал в Системе</p>
                        <a :href="item.link" target="_blank" rel="noopener noreferrer"><span style="font-size: 12px;">{{ `${item.link}` }}</span></a>
                    </div>
                </div>
            </v-expand-transition>
         </div>
       </div>
       <div class="diagnosticResults-btn">
            <v-btn v-if="assesmentFlag" @click="back" class="btn-card">Закрыть</v-btn>
           <v-btn v-else class="btn-card" :disabled="loadSaveResult" @click="back">Вернуться к списку тестов</v-btn>
           <!-- <v-btn :loading="loadSaveResult" @click="saveResult(resultObject)" color="primary" class="ml-2">Сохранить результат</v-btn> -->
       </div>
   </div>
</template>

<script>
import timerComponent from '@/components/Timer/index.vue';
import { mapActions, mapMutations, mapGetters } from 'vuex'

export default {
    name: 'DiagnosticResultsMobile',
    components: { timerComponent },
    props: {
        dialog: { type: Boolean, default: false },
        assesmentFlag: { type: Boolean, default: false },
    },
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl',
            resultObject: 'diagnosticTest/getResultObject'
        }),
        prettyTime () {
            if(!this.resultObject.timer) return;

            let s = this.resultObject.timer.split('T')[1],
                hours = +s.split(':')[0],
                minutes = +s.split(':')[1],
                seconds = +s.split(':')[2];

            return `${Math.floor(hours)}:${Math.floor(minutes)}:${Math.floor(seconds)}`
        },
        etalonTime () {
            // console.log(this.data.etalonMinutes);
            let hours = this.resultObject.etalonMinutes / 60,
                minutes = this.resultObject.etalonMinutes % 60,
                seconds = 0
            // console.log(hours, minutes, seconds);
            return `${Math.floor(hours)}:${Math.floor(minutes)}:${Math.floor(seconds)}`
		}
   },
    data() {
        return {
            passTypes: [],
            loadSaveResult: false
        }
    },
   methods: {
        ...mapActions({
            saveResultTest: 'takeDiagnosticTest/saveResultTest',
            addOrUpdateDiaTestProcessResult: 'takeDiagnosticTest/addOrUpdateDiaTestProcessResult',
            getDiaTestProcessResult: 'diagnosticTest/getDiaTestProcessResult'
        }),
        ...mapMutations({
            changeFlagShow: 'takeDiagnosticTest/changeFlagShow'
        }),
        loadPassTypes() {
            this.$http.get(`${this.apiUrl}TestTask/GetPassTypes`)
                .then((response) => {
                    this.passTypes = response.data;
            });
        },
        getPassTypeId(keyName) {
            let found = this.passTypes.find(x => x.keyName === keyName);

            if (found !== undefined) {
                return found.id;
            }

            return null;
        },
        getPassTypeBadgeClass(result) {
            if (result.passTypeId === this.getPassTypeId('SelfStudy')) {
                return 'badge-selfstudy';
            }

            if (result.passTypeId === this.getPassTypeId('Control')) {
                return 'badge-control';
            }

            return '';
        },
        getPhotoUrl(student) {
            if (student.logoUrl) {
                return `${this.apiImg}${student.logoUrl}`;
            }

            if (student.gender === 0) {
                return require('@/assets/img/avatar-boy.png');
            }

            if (student.gender === 1) {
                return require('@/assets/img/avatar-girl.png');
            }

            return require('@/assets/img/default-profile-image.png');
        },
        back() {
            if (this.assesmentFlag) {
                this.$emit('close');
            }
            else{
                this.changeFlagShow(false)
            this.$router.replace('/lkstudents/tests')
            }
        }
    },
    created() {
        this.loadPassTypes();
        this.changeFlagShow(true);
        this.getDiaTestProcessResult(this.$route.params.id);

        console.log(this.resultObject.criteries);
    }
}
</script>
